import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-serial-confirmation-dialog',
  imports: [MatButtonModule, MatDialogModule, MatIcon],
  templateUrl: './serial-confirmation-dialog.component.html',
  styleUrl: './serial-confirmation-dialog.component.scss',
})
export class SerialConfirmationDialogComponent {}
